/**
 * Applies the active workspace's branding (primary-color override) at app
 * level: on session hydrate, on workspace switch, and instantly when the
 * Settings form saves (via the branding event). Renders nothing.
 */
import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { applyBranding, subscribeBranding } from '../../lib/branding';

const TenantBrandingEffect: React.FC = () => {
  const { activeMembership } = useAuth();
  const styling = activeMembership?.tenant?.styling;

  useEffect(() => {
    applyBranding(styling);
    return () => applyBranding(null);
  }, [styling]);

  useEffect(() => subscribeBranding(applyBranding), []);

  return null;
};

export default TenantBrandingEffect;
